/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssistantToolsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSISTANT_TOOLS_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AssistantToolsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssistantToolsEnabledSettingParser.decode(input).map(res => new AssistantToolsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AssistantToolsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssistantToolsEnabledSettingParser.encode(data);
    }
    static schema() {
        return AssistantToolsEnabledSettingParser.schema();
    }
}
